export const ROLES = [
  {
    value: "client overseer",
    label: "Overseer",
    permission: "overseer",
    hasOnlyRootOrganisation: false
  },
  {
    value: "client hiring manager",
    label: "Hiring Manager",
    permission: "hiring-manager",
    hasOnlyRootOrganisation: false
  },
  {
    value: "client booking approver",
    label: "Role Approver",
    permission: "booking-approver",
    hasOnlyRootOrganisation: false
  },
  {
    value: "client interviewer",
    label: "Interviewer",
    permission: "interviewer",
    hasOnlyRootOrganisation: false
  },
  {
    value: "msp user",
    label: "MSP User",
    permission: "msp-user",
    hasOnlyRootOrganisation: false
  },
  {
    value: "msp admin",
    label: "MSP Admin",
    permission: "msp-administrator",
    hasOnlyRootOrganisation: false
  }
];
